import primaryTheme from 'constants/primaryTheme';
import dangerTheme from 'constants/dangerTheme';
import warningTheme from 'constants/warningTheme';
import infoTheme from 'constants/infoTheme';
import accentTheme from 'constants/accentTheme';
import successTheme from 'constants/successTheme';

// sidebar background images
export const sidebarBackgroundImages = [
  {
    id: 1,
    url: '//public-common-sdk.s3.ap-northeast-2.amazonaws.com/image/front-static/sidebar-1.jpg'
  },
  {
    id: 2,
    url: '//public-common-sdk.s3.ap-northeast-2.amazonaws.com/image/front-static/sidebar-2.jpg'
  },
  {
    id: 3,
    url: '//public-common-sdk.s3.ap-northeast-2.amazonaws.com/image/front-static/sidebar-3.jpg'
  },
  {
    id: 4,
    url: '//public-common-sdk.s3.ap-northeast-2.amazonaws.com/image/front-static/sidebar-4.jpg'
  }
];

// sidebar filters
export const sidebarFilters = [
  {
    id: 1,
    class: 'sidebar-overlay-dark',
    name: 'Dark'
  },
  {
    id: 2,
    class: 'sidebar-overlay-light',
    name: 'Light'
  },
  {
    id: 3,
    class: 'sidebar-overlay-pink',
    name: 'Danger'
  },
  {
    id: 4,
    class: 'sidebar-overlay-primary',
    name: 'Primary'
  },
  {
    id: 5,
    class: 'sidebar-overlay-warning',
    name: 'Warning'
  },
  {
    id: 6,
    class: 'sidebar-overlay-success',
    name: 'Success'
  },
  {
    id: 7,
    class: 'sidebar-overlay-purple',
    name: 'Info'
  }
];

// router animations
export const routerAnimations = ['slideInUp', 'fadeIn', 'slideInRight', 'bounce', 'lightSpeedIn', 'pulse'];

// themes
export const themes = [
  {
    id: 1,
    bgColor: 'bg-primary',
    theme: primaryTheme
  },
  {
    id: 2,
    bgColor: 'bg-warning',
    theme: warningTheme
  },
  {
    id: 3,
    bgColor: 'bg-success',
    theme: successTheme
  },
  {
    id: 4,
    bgColor: 'bg-danger',
    theme: dangerTheme
  },
  {
    id: 5,
    bgColor: 'bg-info',
    theme: infoTheme
  },
  {
    id: 6,
    bgColor: 'bg-secondary',
    theme: accentTheme
  }
];

// header filter
export const headerFilters = [
  {
    id: 1,
    class: 'primary'
  },
  {
    id: 2,
    class: 'light'
  },
  {
    id: 3,
    class: 'warning'
  },
  {
    id: 4,
    class: 'success'
  },
  {
    id: 5,
    class: 'error'
  },
  {
    id: 6,
    class: 'info'
  }
];



// WEBPACK FOOTER //
// ./src/store/modules/settings/data.js